<p-colorpicker
  [ngModel]="value()"
  (ngModelChange)="value.set($event)"
  [inline]="inline()"
  [disabled]="disabled()"
  (onChange)="handleChange($event)">
</p-colorpicker>
